export const statusDropDownStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    container: (provided) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        boxShadow: 'none',
        marginLeft: '6px',
        paddingBottom: '0px',
        width: '100%',
        minWidth: '285px',
        '&:hover': {
            borderColor: '#d3d4d8'
        },
        zIndex: '1000'
    }),
    control: (provided) => ({
        ...provided,
        boxShadow: 'none',
        borderRadius: '8px',
        height: '32px',
        minHeight: '32px',
        paddingBottom: '5px',
        width: '100%',
        minWidth: '285px',
        '&:hover': {
            borderColor: '#006d9e',
            boxShadow: 'none',
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        paddingTop: '5px',
        width: '207px',
        minWidth: '207px',
        color: '#343A40'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        paddingTop: '6px',
        paddingBottom: '7px',
        color: '#373737',
        '& svg': {
            opacity: '0'
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        marginTop: '-6px',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    option: (provided, state) => ({
        ...provided,
        ...(state.data.isDisabled && { cursor: 'not-allowed', opacity: 0.5 }),
        fontFamily: "'Montserrat', sans-serif",
        paddingTop: '1px',
        paddingBottom: '1px',
        backgroundColor: state.isFocused ? '#0D6EFD' : '#ffffff',
        color: state.isFocused ? '#ffffff' : '#222222',
        '&:hover': {
            backgroundColor: state.isFocused ? '#0D6EFD !important' : '#ffffff',
            color: state.isFocused ? '#ffffff' : '#222222',
            outline: 0,
        }
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        position: 'absolute',
        right: '8px',
        top: '50%',
        paddingTop: '2px',
        transform: 'translateY(-50%)',
        backgroundSize: "12px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 0.75rem center",
        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e")'
    }),
    menu: (provided) => ({
        ...provided,
        top: "25px !important"
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingTop: '2px',
        width: "207px",
        minWidth: '207px',
        position: 'static'
    }),
    singleValue: (provided) => ({
        ...provided,
        width: '100%',
        minWidth: '285',
        whiteSpace: 'unset',
        overflow: 'visible',
        paddingTop: '5px',
        fontWeight: "normal"
    }),
};
